/**
 * @owner @Appboy/clx
 */

import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";
import { common } from "../common";

export const sendToDestinationStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("SEND_TO_DESTINATION"),
  step_data: z.object({
    // null until a destination Canvas has been picked (draft steps).
    destination_canvas_id: common.objectId.nullable(),
  }),
});
